import { of, pipe } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { State } from '../services/work.state';

export const closeDisable = () =>
  pipe(
    switchMap(([state, currentState]: [Partial<State>, State]) => {
      if (state.system?.closeDisable !== undefined) {
        const newState = {
          ...state,
          ...{
            closeDisable: state.system?.closeDisable,
            system: {
              ...state.system,
              ...{
                closeDisable: undefined,
              },
            },
          },
        };
        return of([newState, currentState] as [Partial<State>, State]);
      }

      return of([state, currentState] as [Partial<State>, State]);
    })
  );
